import AxiosClient from "../../services/axios.services";

class TaskServices {
  getTasks = (params, iType) =>
    AxiosClient.get(
      iType === 1
        ? "/api/app/Formal_Funciones/"
        : "/api/app/Funcional_Funciones/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getTasksDescriptors = (params) =>
    AxiosClient.get(
      "/api/app/Funcional_Funciones_filtrado_unidad_organizativa/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  saveTask = (data, iType) =>
    AxiosClient.post(
      iType === 1
        ? "/api/app/Formal_Funciones/"
        : "/api/app/Funcional_Funciones/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editTask = (id, data, iType) =>
    AxiosClient.put(
      iType === 1
        ? `/api/app/Formal_Funciones/${id}/`
        : `/api/app/Funcional_Funciones/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteTask = (id, iType) =>
    AxiosClient.delete(
      iType === 1
        ? `/api/app/Formal_Funciones/${id}/`
        : `/api/app/Funcional_Funciones/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new TaskServices();
